import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { hideModal } from "../../../usecases/commons/hide-modal";

const HexModal = ({ children }) => {
  return (
    <Modal
      isOpen
      overlayClassName="Modal-overlay"
      onRequestClose={() => hideModal()}
      contentLabel="modal"
      ariaHideApp={false}
      className={{
        base: "ReactModal__Overlay ReactModal__Content",
        afterOpen: "ReactModal__Overlay--after-open fadeIn",
        beforeClose: "ReactModal__Overlay--before-close fadeOut",
      }}
    >
      {children}
    </Modal>
  );
};

HexModal.defaultProps = {};
HexModal.propTypes = { children: PropTypes.node.isRequired };

export default HexModal;
